import lblLayout from '@/layouts/lbl'

export default [
  {
    name: 'fac',
    path: '/',
    redirect: '/factory',
    component: lblLayout,
    children: [
      {
        name: 'factory',
        path: '/factory',
        component: () => import('_fac/factory'),
        meta: {
          title: '立林智慧生活APP-智家互联(厂商列表)'
        }
      },
      {
        name: 'facDeviceList',
        path: '/factory/DeviceList/:id',
        component: () => import('_fac/factory/DeviceList'),
        meta: {
          title: '立林智慧生活APP-智家互联(设备列表)'
        }
      }
    ]
  }
]
